import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import Move from './Move';
import ApiError from '@/lib/shared-coms/ApiError';
import { BULK_INVENTORY_EVENT_CREATE } from '@/lib/graphql/fragments';
import { useRootStore } from '@/lib/providers/RootProvider';

const SERIALIZED_ITEM_STATE = gql`
  query serializedItemState($serialNumber: String!, $gtin: String, $companyId: ID!) {
    serializedItemState(serialNumber: $serialNumber, gtin: $gtin, companyId: $companyId) {
      status
      lot
      expiration
      serialNumber
      gtin
      serializedItemType
      zone {
        id
        name
        zoneType
      }
      purchaseOrder {
        id
        clientPurchaseOrderNumber
      }
      pedigree {
        SSCC
        CA
        PK
        ITEM
      }
      itemBreakdown {
        quantity
        status
        lot
        expiration
        product {
          id
          title
          fdaProduct {
            id
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
    }
  }
`;

const MoveData = (props) => {
  const [bulkInventoryEventCreate] = useMutation(BULK_INVENTORY_EVENT_CREATE);
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get('serialNumber');
  const gtin = searchParams.get('gtin');
  const selectedCompanyId = useRootStore((state) => state.selectedCompany?.id);

  const { data, error, loading } = useQuery(SERIALIZED_ITEM_STATE, {
    variables: { serialNumber, gtin, companyId: selectedCompanyId }
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { serializedItemState } = data || {};

  return (
    <Move
      serializedItemState={serializedItemState}
      bulkInventoryEventCreate={bulkInventoryEventCreate}
      selectedCompanyId={selectedCompanyId}
      {...props}
    />
  );
};

export default MoveData;
